import { render, staticRenderFns } from "./loading2.vue?vue&type=template&id=a08446a0&scoped=true&"
import script from "./loading2.vue?vue&type=script&lang=js&"
export * from "./loading2.vue?vue&type=script&lang=js&"
import style0 from "./loading2.vue?vue&type=style&index=0&id=a08446a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08446a0",
  null
  
)

export default component.exports